export enum ModuleType {
  None = 0,
  Rbh = 1,
  RequestServiceable = 2,
  RequestUnserviceable = 3,
  Pbh = 4,
  PbhRequestServiceable = 5,
  PbhRequestUnserviceable = 6,
  Both = 99,
}
